import { MpShopPlusTermsTmplS } from '../../../../MpShopPlus/Terms/S/Tmpl/module/MpShopPlusTermsTmplS.js';

export const nbox20231018 = (lang) => MpShopPlusTermsTmplS.nbox_terms_popup(lang || T.lang);
